import 'react-perfect-scrollbar/dist/css/styles.css';
import React, { useEffect, useState } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/app/components/GlobalStyles';
import theme from 'src/app/theme';
import routes from 'src/routes';
import moment from 'moment';
import { GetUserInfo } from './features/authSlice'
import { startTokenWatcher } from './app/tokenSession';
import 'antd/dist/antd.css';

import './App.css';
import 'moment/locale/vi';
require('dotenv');

const MAX_RETRY_USER_INFO = 3;

const App = () => {
  const dispatch = useDispatch();
  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const errGetting = useSelector(state => state.authSlice.errGetting);
  const [retryUserInfo, setRetryUserInfo] = useState(0);
  const location = useLocation();
  const isAppDownloadRoute = location.pathname === '/app-download';
   const isAppPrivacyRoute = location.pathname === '/privacy-policy';

  useEffect(() => {
    if (!dataLogin && !isAppDownloadRoute && !isAppPrivacyRoute) {
      dispatch(GetUserInfo());
    }
  }, [dataLogin, dispatch, isAppDownloadRoute, isAppPrivacyRoute, retryUserInfo]);

  // Lời gọi này quyết định vai trò của người dùng (isAdmin/isAgency/isUser). Nếu nó
  // hỏng thì `dataLogin` vẫn null, mà deps của effect trên KHÔNG đổi, nên trước đây
  // không có lần thử lại nào: cả phiên làm việc kẹt ở trạng thái "không phải quản
  // trị". Hậu quả thấy được là ô "Đơn vị kinh doanh vận tải" trong báo cáo trống
  // trơn, vì danh sách đơn vị chỉ được nạp khi isAdmin bật.
  //
  // Giãn dần 2s/4s/6s rồi thôi — hỏng dai là mạng hoặc phiên hết hạn, thử mãi chỉ
  // đập thêm vào máy chủ.
  useEffect(() => {
    if (dataLogin || !errGetting || retryUserInfo >= MAX_RETRY_USER_INFO) return undefined;
    const timer = setTimeout(() => setRetryUserInfo(n => n + 1), 2000 * (retryUserInfo + 1));
    return () => clearTimeout(timer);
  }, [dataLogin, errGetting, retryUserInfo]);

  // Proactive session keep-alive: refresh the token before it expires and
  // force re-login when the refresh chain is dead (idle tab scenario).
  useEffect(() => {
    startTokenWatcher();
  }, []);

  moment.locale('vi');
  const routing = useRoutes(routes);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}
    </ThemeProvider>

  );
};

export default App;
